// extracted by mini-css-extract-plugin
module.exports = {"container":"MapAreaContainer_container__1slnr"};